import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';

import iconPromiseMonayBack from '../../../assets/images/ourclub/icons/promise-money-back.png';
import iconPromiseTailoredExperience from '../../../assets/images/ourclub/icons/promise-tailored-experience.png';
import iconPromiseExclusiveContent from '../../../assets/images/ourclub/icons/promise-exclusive-content.png';
import iconPromiseCommunityLeaders from '../../../assets/images/ourclub/icons/promise-community-ambassadors.png';

const promises = [
    {
      icon: iconPromiseMonayBack,
      title: "15 zile banii înapoi",
    },
    {
      icon: iconPromiseTailoredExperience, 
      title: "Tailored Experience",
    },
    {
      icon: iconPromiseExclusiveContent,
      title: "Conținut exclusiv",
    },
    {
      icon: iconPromiseCommunityLeaders,
      title: "Experiență personalizată 1 la 1",
    },
];

const PromisesSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#262626',
        py: { xs: 3, xxl: 6 },
        px: 2,
        textAlign: 'center'
      }}
    >
        <Box
            sx={{
                width: { xs: "100%", xxl: "70%" },
                margin: "0 auto"
            }}
        >
            <Typography
                variant="h2"
                sx={{
                    fontWeight: 'bold',
                    fontSize: { xs: "20px", xxl: "36px" },
                    color: '#20defa',
                    mb: { xs: 2, xxl: 4 }
                }}
            >
                Promisiunea noastră față de tine
            </Typography>
            
            {/* <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                flexWrap="wrap"
                gap={{ xs: 0, xxl: 4 }}
                sx={{  
                    width: "100%", 
                    margin: "0 auto" 
                }}
            >
              {promises.map((promise, index) => (
                <Box
                  key={`${promise.id}-${index}`}
                  sx={{
                    display: "flex",
                    flexDirection: {xs: "row", xxl: "row"},
                    alignItems: "center",
                    textAlign: { xs: "center", xxl: "left" },
                    gap: { xs: 1, xxl: 2 },
                    flex: {
                      xs: '1 1 100%',
                      xxl: '1 1 0',
                    },
                    minWidth: {
                      xs: '100%',
                      xxl: '0',
                    },
                    p: 2,
                    borderRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      width: "75px",
                      height: "75px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#F6F6F6",
                      borderRadius: "12px",
                      boxShadow: "0px 10px 20px 0px rgba(0, 0, 0, 0.18)"
                    }}
                  >
                    <img
                      src={promise.icon}
                      alt={promise.title}
                      style={{
                        width: "55px",
                        height: "55px",
                        objectFit: "contain",
                        padding: "3px 3px"
                      }}
                    />
                  </Box>
        
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 2,
                      color: "#fff",
                      textAlign: "left",
                      fontWeight: "700", 
                      fontSize: { xs: "12px", xxl: "16px" }, 
                    }}
                  >
                    {promise.title}
                  </Typography>
                </Box>
              ))}
            </Stack> */}

            {/* Icon Feature Grid */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: { xs: 2, xxl: 4.3 }, flexWrap: 'wrap', mb: 2 }}>
                {promises.map((promise, idx) => (
                <Box
                    key={idx}
                    sx={{
                        border: '1px solid #000',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        p: 3,
                        textAlign: 'center',
                        width: { xs: '100%', xxl: '23%' },
                        height: "100%",
                        fontSize: { xs: "36px", xxl: "48px" }
                    }}
                >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "12px",
                        mb: 2
                      }}
                    >
                      <img
                        src={promise.icon}
                        alt={promise.title}
                        style={{
                          width: "55px",
                          height: "55px",
                          objectFit: "contain",
                          padding: "3px 3px"
                        }}
                      />
                    </Box>
                    <Typography sx={{ color: '#002077', fontWeight: 600, fontSize: { xs: "12px", xxl: "16px" } }}>
                        {promise.title}
                    </Typography>
                </Box>
                ))}
            </Box>
        
            <Button
                variant="contained"
                fullWidth={false}
                href="/contact"
                sx={{
                mt: { xs: 2, xxl: 4 },
                px: { xs: 2, sm: 4 },
                py: { xs: 0, sm: 2 },
                backgroundColor: "#fff",
                color: "#002077",
                borderRadius: "16px",
                textTransform: "none",
                fontWeight: "700", 
                fontSize: { xs: "16px", sm: "18px", md: "20px" }, 
                lineHeight: "14px",
                letterSpacing: "normal",
                "&:hover": {
                    backgroundColor: "#20defa",
                    color: "#fff",
                },
                }}
            >
                Intră în comunitate
            </Button>
        </Box>
    </Box>
  );
};

export default PromisesSection;